import { SortDescriptor } from '@progress/kendo-data-query';
import { Lookup } from '../../../../shared/models';

export class UsersActivitiesLookup extends Lookup {
  action: string = null;
  from: Date = null;
  to: Date = null;
  sort: Array<SortDescriptor> = [{dir: 'desc', field: 'time'}];

  constructor(data?: any) {
    super(data);
  }
}
